import { useMediaQuery } from "@mui/material";

import AppIconButton from "@/common/components/Button/AppIconButton";
import AppIcon from "@/common/components/Icons/AppIcon";
import { useAppThunkDispatch } from "@/common/hooks/redux";
import { NavDisplayVariants, useNavDisplay } from "@/common/useNavDisplay";
import * as appCommonSlice from "@/store/appCommon/slice";

export function NavToggleButton() {
  const thunkDispatch = useAppThunkDispatch();
  const { navDisplay, navToggle } = useNavDisplay();
  const isMobile = useMediaQuery((t) => t.breakpoints.down("md"));

  return (
    <>
      <AppIconButton
        sx={{ ml: { xxs: 1, md: 3.5 }, mr: { xxs: 1, md: 4.5 } }}
        variant='text'
        size='medium'
        color='text'
        title={`${navDisplay === NavDisplayVariants.collapsed ? "Expand" : "Collapse"} navigation`}
        onClick={(e) => {
          e.stopPropagation();
          if (isMobile) {
            thunkDispatch(appCommonSlice.toggleNav());
          } else {
            navToggle && navToggle({ variant: "button" });
          }
        }}
      >
        <AppIcon of='menu' />
      </AppIconButton>
    </>
  );
}
